<template>
  <div>
    <section id="sub_visual" class="pic08">
      <p>총무닷컴 소개</p>
      <span>About Chongmu Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con08 clear">
        <h6>총무와 총무가 만나는 <br/>
          소통의 공간</h6>
        <span class="ctext1">총무닷컴은 경영지원 업무의 표준 가이드를 제공하며 <br/>
      총무와 총무가 만나는 소통공간입니다. </span>
        <p class="ctext2"><span class="cbig">Why etners</span><span>Chongmu.com?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_29.png" width="104" height="104" alt=""/></p>
              <h6>경영지원 업무의 표준 가이드</h6>
              <p>총무, 급여, 복리후생, 외국인지원 등
                경영지원에 필요한 전문지식과 정보를 공유합니다. </p>
            <li>
              <p><img src="../../assets/images/c_im_30.png" width="104" height="104" alt=""/></p>
              <h6>경영지원 정보와 뉴스 공유</h6>
              <p>경영지원 담당자가 알아야할 최신 동향과
                시사, 법률, 매거진과 칼럼까지 공유합니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_31.png" width="104" height="104" alt=""/></p>
              <h6>실무전문가의 24시간 이내 답변</h6>
              <p>경영지원에 필요한 무엇이든 물어보세요.
                실무전문가가 직접 답변해드립니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_32.png" width="104" height="104" alt=""/></p>
              <h6>총무와 총무가 만나는 소통공간 </h6>
              <p>기업 내 총무 담당자가 전략적 활동업무에 집중할 수 있도록  총무와 총무가 만나는 소통을 지원합니다. </p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://www.chongmu.com',
        solNm :'총무닷컴',
        solCd : '2005'
      }
    }
  }

</script>
